import { useColorModeValue } from "native-base";

export default useColorModeValue;